var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Discussion-CommentReport-Root {\n  cursor: pointer;\n  position: relative;\n}\n.Discussion-CommentReport-Icon {\n  width: 24px;\n  height: 24px;\n  background-image: url(" + escape(require("../resources/report.svg")) + ");\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: 18px 16px;\n}\n", ""]);

// exports
